<template>
  <div>
    <a-modal title="红字增值税专用发票信息表信息选择" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <div v-if="tableWindow">
        <div>
          <select name="" id="" v-model="taxClass">
            <option value="0">专用发票</option>
          </select>
        </div>
        <div class="mt-50">
          <div class="formCode">
            <div class="circle"></div>
            <div>
              <span>开具红字增值税专用发票信息表信息选择</span>
              <div>
                <a-radio-group v-model="apply" @change="applyChange">
                  <a-radio value="0" style="display: block">
                    一、购买方申请
                    <a-radio-group
                      v-model="deduction"
                      :disabled="apply === ''"
                      @change="deductChange"
                      style="display: block; margin-left: 20%"
                    >
                      <a-radio value="0" style="display: block"> 1、已抵扣 </a-radio>
                      <a-radio value="1"> 2、未抵扣</a-radio>
                    </a-radio-group>
                  </a-radio>
                  <a-radio value="1"> 二、销售方申请 </a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
          <div class="formCode mt-20">
            <div class="circle"></div>
            <div>
              <span>对应蓝字增值税专用发票信息</span>
              <div class="flex mt-20">
                <div class="mr-1">
                  发票代码：<input
                    type="text"
                    v-model="taxBillCode"
                    @change="deductChange"
                    :disabled="apply === '0' && deduction === '0'"
                  />
                </div>
                <div>
                  发票号码：<input
                    type="text"
                    v-model="taxBillNo"
                    @change="deductChange"
                    :disabled="apply === '0' && deduction === '0'"
                  />
                </div>
                <!-- <div>开票时间<input type="text" /></div> -->
              </div>
              <div class="flex">
                <div class="mr-1 taxTime">
                  开票时间：<select v-model="kpYear" disabled>
                    <option :value="kpYear">{{ kpYear }}</option></select
                  >年<select v-model="kpMonth" disabled>
                    <option :value="kpMonth">{{ kpMonth }}</option></select
                  >月
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--下个页面-->
      <div v-if="!tableWindow">
        <div>本张发票可以开具红字发票</div>
        <div class="next-window-body">
          <div class="next-window-item" tabindex="1">
            <div tabindex="1">类别代码：</div>
            <div tabindex="1">{{ invoiceData.taxBillCode }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">发票号码：</div>
            <div tabindex="1">{{ invoiceData.taxBillNo }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">购方名称：</div>
            <div tabindex="1">{{ invoiceData.buyerName }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">购方税号：</div>
            <div tabindex="1">{{ invoiceData.buyerTaxPayerId }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">购方电话地址：</div>
            <div tabindex="1">{{ invoiceData.buyerAddress }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">购方银行账户：</div>
            <div tabindex="1">{{ invoiceData.buyerAccounts }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">合计金额(不含税)：</div>
            <div tabindex="1">{{ invoiceData.totalGoodsPrice }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">合计税额：</div>
            <div tabindex="1">{{ invoiceData.totalTaxPay }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">开票日期：</div>
            <div tabindex="1">{{ invoiceData.taxBillDate }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">开票人：</div>
            <div tabindex="1">{{ invoiceData.drawer }}</div>
          </div>
          <div class="next-window-item">
            <div tabindex="1">作废标志：</div>
            <div tabindex="1">{{ invoiceData.isVoid == 'Y' ? '是' : '否' }}</div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button key="pro" type="primary" v-if="!tableWindow" @click="proStep()"> 上一步 </a-button>
        <a-button key="next" type="primary" v-if="tableWindow" @click="nextStep()" :disabled="next"> 下一步 </a-button>
        <a-button key="submit" type="primary" @click="handleOk" :disabled="isSubmit"> 确定 </a-button>
        <a-button key="back" type="primary" @click="handleCancel"> 取消 </a-button>
      </template>
    </a-modal>
    <red-invoice ref="redInvoiceModal"></red-invoice>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'
import redInvoice from '@/views/redInvoice.vue'
export default {
  components: {
    redInvoice,
  },
  data() {
    return {
      visible: false,
      taxClass: 0,
      kpYear: '',
      kpMonth: '',
      apply: '',
      deduction: '',
      taxBillCode: '',
      taxBillNo: '',
      tableWindow: true,
      isSubmit: true, // 提交
      next: true, // 下一步
      invoiceData: {
        taxBillCode: '',
        taxBillNo: '',
        buyerName: '',
        buyerTaxPayerId: '',
        buyerAddress: '',
        buyerAccounts: '',
        totalGoodsPrice: '',
        totalTaxPay: '',
        taxBillDate: '',
        drawer: '',
        isVoid: '',
        apply: '',
        deduction: '',
        taxClass: '',
      },
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.initState()
    },
    applyChange() {
      this.deduction = ''
      this.isSubmit = true
      this.deductChange()
    },
    async deductChange() {
      if (this.apply === '0') {
        if (this.deduction === '0') {
          this.isSubmit = false
        } else if (this.deduction === '1') {
          if (this.taxBillCode !== '' && this.taxBillNo !== '') {
            this.isSubmit = false
          } else {
            this.isSubmit = true
          }
        }
      } else if (this.apply === '1') {
        this.next = !(this.taxBillCode.length >= 10 && this.taxBillNo.length >= 8)
        this.kpYear = ''
            this.kpMonth = ''
        if (!this.next) {
          const res = await this.getInvocieInfo()
          if (res) {
            const taxBillDate = res.data.taxBillDate.split('-')
            this.kpYear = taxBillDate[0]
            this.kpMonth = taxBillDate[1]
          }
        }
      }
    },
    initState() {
      this.taxBillCode = ''
      this.taxBillNo = ''
      this.taxClass = '0'
      this.apply = ''
      this.deduction = ''
      this.tableWindow = true
      this.isSubmit = true
      this.next = true
      this.invoiceData = {
        taxBillCode: '',
        taxBillNo: '',
        buyerName: '',
        buyerTaxPayerId: '',
        buyerAddress: '',
        buyerAccounts: '',
        totalGoodsPrice: '',
        totalTaxPay: '',
        taxBillDate: '',
        drawer: '',
        isVoid: '',
        apply: '',
        deduction: '',
        taxClass: '',
      }
    },
    // 跳转 开具红字增值税专用发票信息表
    toRedInfoSheet() {
      this.invoiceData.taxClass = '0'
      this.invoiceData.apply = this.apply
      this.invoiceData.deduction = this.deduction
      this.$refs.redInvoiceModal.show(this.invoiceData)
      this.handleCancel('showModelVisible')
    },
    handleOk() {
      if (this.apply === '0') {
        // 购买方
        if (this.deduction === '0') {
          // 已抵扣不需要请求接口 直接跳转
          this.toRedInfoSheet()
        } else if (this.deduction === '1') {
          // 未抵扣
          this.getInvocieInfo()
        }
      } else if (this.apply === '1') {
        this.toRedInfoSheet()
      }
    },
    // 上一步
    proStep() {
      this.isSubmit = true // 提交按钮
      this.tableWindow = true
    },
    // 下一步
    async nextStep() {
      const res = await this.getInvocieInfo()
      if (res.statusCode === '200') {
        this.invoiceData = res.data
        if (this.apply === '1') {
          // 销售方 还有一个下一步
          this.tableWindow = false
          this.isSubmit = false
        } else if (this.apply === '0') {
          // 购买方直接跳转
          this.toRedInfoSheet()
        }
      } else {
        this.$info({
          title: '提示',
          content: res.msg,
        })
      }
    },
    async getInvocieInfo() {
      const params = parseParam({
        taxBillCode: this.taxBillCode.trim(),
        taxBillNo: this.taxBillNo.trim(),
        taxClass: '0',
        apply: this.apply,
        deduction: this.deduction,
      })
      const res = await this.$http.post(`${Urls.getInvocieInfo}&${params}`)
      return res
    },
  },
}
</script>

<style lang="less" scoped>
.formCode {
  display: flex;
  align-items: baseline;
}
.next-window-body {
  border: 1px solid #1890ff;
}
.next-window-item {
  display: flex;
}
.taxTime {
  select {
    height: 30px;
    width: 70px;
  }
}
</style>
